export default function FloatWhatsApp({ settings }) {
  return (
    <a
      href={`https://wa.me/${settings.whatsapp}`}
      className="float-wa"
      target="_blank"
      rel="noopener"
      title="Chat with us"
    >
      <i className="fa-brands fa-whatsapp" />
    </a>
  );
}
